const COOKIE_NAME = 'cookie_policy';
const COOKIE_DAYS = 30;

const getCookie = (name) => {
  const match = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
  );
  return match ? decodeURIComponent(match[1]) : null;
};

const setCookie = (name, value, days) => {
  const maxAge = days * 24 * 60 * 60;
  const expires = new Date(Date.now() + maxAge * 1000).toUTCString();

  document.cookie = [
    name + '=' + encodeURIComponent(value),
    'expires=' + expires,
    'max-age=' + maxAge,
    'path=/',
    'SameSite=Lax'
  ].join('; ');
};

const cookiesBar = () => {
  const bar = document.querySelector('.js-cookies');

  if (!bar) return;

  // Cached pages can still include the bar after consent — honour the cookie client-side
  if (getCookie(COOKIE_NAME)) {
    bar.remove();
    return;
  }

  const btn = bar.querySelector('.btn');

  if (!btn) return;

  btn.addEventListener('click', () => {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    bar.remove();
  });
};

export default cookiesBar;
